import React from 'react'
import handleViewport from 'react-in-viewport'
import styled from 'styled-components'

const AnimatedLetter = styled.span`
    transform: translate(0, -100px);
    display: inline-block;
    transition: all 1.2s cubic-bezier(0.19, 1, 0.22, 1);
    opacity: 0;
    font-size: ${props => props.fontSize ? props.fontSize : "100px"};
    line-height: ${props => props.lineHeight ? props.lineHeight : "90px"};
    font-family: Teko;
    text-transform: uppercase;
    @media (max-width: 767px) {
        font-size: 40px;
        line-height: 40px;
    }
    &.animate, &.animation_complete {
        transform: translate(0, 0);
        opacity: 1;
    }
`
const Space = styled.span`
    font-size: 100px;
    margin: 0 ${props => props.space ? props.space : "10px"};
    @media (max-width: 767px) {
        font-size: 40px;
        line-height: 40px;
        margin: 0 5px;
    }
`

class Animated_Heading extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            inViewport: false,
            animation_complete: false,
            animate: false,
            force: false
        }
    }

    componentDidMount() {
        this._isMounted = true;

        // Check if page reveal already happened
        if (typeof window !== 'undefined' && window.__pageRevealed) {
            if (this.props.inViewport && !this.state.animation_complete) {
                setTimeout(() => {
                    if (this._isMounted) this.triggerAnimation();
                }, 50);
            }
            return;
        }

        // Wait for the pageRevealed signal before responding to viewport
        this._onPageRevealed = () => {
            if (this.props.inViewport && !this.state.animation_complete && !this.state.animate) {
                setTimeout(() => {
                    if (this._isMounted) this.triggerAnimation();
                }, 50);
            }
        };
        if (typeof window !== 'undefined') {
            window.addEventListener('pageRevealed', this._onPageRevealed);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this._onPageRevealed && typeof window !== 'undefined') {
            window.removeEventListener('pageRevealed', this._onPageRevealed);
        }
    }

    triggerAnimation = () => {
        if (this.state.animate) return;
        this.setState({animate: true})
        let delay = 1
        this.props.text.split(" ").forEach(function(value, index) {
            value.split("").forEach(function(v, i) {
                ++delay
            })
        })
        setTimeout(() => {
            if (this._isMounted) {
                this.setState({animation_complete: true})
            }
        }, (delay*200)+500)
    }

    componentDidUpdate() {
        const pageReady = typeof window !== 'undefined' && window.__pageRevealed;
        if (pageReady && this.props.inViewport && !this.state.animate && !this.state.animation_complete) {
            this.triggerAnimation();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.animation_complete && !this.props.inViewport) {
            return false
        } else {
            return true
        }
    }

    render() {
        // react-in-viewport injects innerRef (or forwardedRef in newer versions)
        const refProp = this.props.innerRef || this.props.forwardedRef || null;
        return (
            <h2 ref={refProp} style={{textAlign: "center", marginBottom: "20px"}} className="heading">
                {this.animate()}
            </h2>
        )
    }

    animate() {
        let time = 0;
        return this.props.text.split(" ").map((value, index, array) => {
            const word = value.split("").map((v, i) => {
                time++;
                return (
                    <AnimatedLetter 
                        key={`letter-${time}`} 
                        fontSize={this.props.fontSize} 
                        lineHeight={this.props.lineHeight} 
                        style={{
                            transitionDelay: `${time*80}ms`, 
                            color: index % 2 !== 0 || this.props.color ? "#04e5e5" : "#fff"
                        }} 
                        className={this.state.animation_complete ? "animation_complete" : (this.state.animate ? "animate" : "")}
                    >
                        {v}
                    </AnimatedLetter>
                );
            });
            
            return (
                <span key={`word-${index}`} style={{ display: 'inline-block' }}>
                    {word}
                    {index !== array.length - 1 && <Space space={this.props.space} />}
                </span>
            );
        });
    }

}
const AnimatedHeading = typeof handleViewport === 'function' 
  ? handleViewport(Animated_Heading) 
  : Animated_Heading;

export default AnimatedHeading;